import { useRef } from 'react';

import { ProjectSelectOption, Status, TestType } from '@qality/common-model';

type Filters = {
  projects: Array<ProjectSelectOption>;
  statuses: Array<Status>;
  textSearch: string;
  testTypes: Array<TestType>;
};

export default function useFiltersBackup(defaultFilters: Filters) {
  const filtersBackup = useRef<Filters>(defaultFilters);

  const backupFilters = (filters: Filters) => {
    filtersBackup.current = filters;
  };

  return { filtersBackup: filtersBackup.current, backupFilters };
}
